import React from 'react';
import { useSelector } from 'react-redux';
import { Content, Panel } from 'rsuite';
import PageHeader from '../../../../components/PageHeader';
import PageLayout from '../../../../containers/inventory/PageLayout';
import ContentLoader from '../../../../components/ContentLoader';
import ResultHeader from './ResultHeader';
import LowStockItemsSearchForm from '../../../../components/inventory/reports/LowStockItemsSearchForm';
import LowStockItemsList from '../../../../components/inventory/reports/LowStockItemsList';
import {
  getIsFetched,
  getIsFetching
} from '../../../../redux/Inventory/selectors/reports/low-stock-items';

export default () => {
  const isFetched = useSelector(getIsFetched);
  const isFetching = useSelector(getIsFetching);
  return (
    <PageLayout>
      <PageHeader title="Low Stock Items">
        <LowStockItemsSearchForm />
      </PageHeader>
      <Content>
        {isFetching && <ContentLoader />}
        {isFetched && (
          <Panel bodyFill bordered header={<ResultHeader />}>
            <LowStockItemsList />
          </Panel>
        )}
      </Content>
    </PageLayout>
  );
};
